export interface IReportSentRequest {
  caseLineItemId: number
  reportSentDate: Date
}

export class ReportSentRequest implements IReportSentRequest {
  public caseLineItemId: number
  public reportSentDate: Date
}
